// root
import { MdastRootVisitor, LexicalRootVisitor } from './root.js'

// paragraph
import { MdastParagraphVisitor, LexicalParagraphVisitor } from './paragraph.js'

// text
import { MdastTextVisitor, LexicalTextVisitor } from './text.js'

// linebreak
import { MdastBreakVisitor, LexicalLinebreakVisitor } from './linebreak.js'

// formatting
import { formattingVisitors } from './formatting.js'

// heading
import { MdastHeadingVisitor, LexicalHeadingVisitor, MdastTOCVisitor, LexicalTOCVisitor } from './heading.js'

// link, embed, media, image
import {
  MdastAutolinkVisitor,
  MdastLinkVisitor,
  LexicalLinkVisitor,
  LexicalEmbedVisitor
} from './link.js'

// media, image, gallery
import {
  MdastImageVisitor,
  LexicalMediaVisitor,
  LexicalGalleryVisitor
} from './media.js'

// quote
import { MdastQuoteVisitor, LexicalQuoteVisitor } from './quote.js'

// list
import {
  MdastListVisitor,
  MdastListItemVisitor,
  LexicalListVisitor,
  LexicalListItemVisitor
} from './list.js'

// code
import { MdastCodeBlockVisitor, LexicalCodeBlockVisitor } from './code.js'

// horizontal rule
import { MdastHorizontalRuleVisitor, LexicalHorizontalRuleVisitor } from './horizontal-rule.js'

// mentions
import {
  MdastUserMentionVisitor,
  MdastTerritoryMentionVisitor,
  LexicalUserMentionVisitor,
  LexicalTerritoryMentionVisitor,
  MdastItemMentionVisitor,
  LexicalItemMentionVisitor
} from './mentions.js'

// nostr ids
import { MdastNostrIdVisitor, LexicalNostrIdVisitor } from './nostr.js'

import {
  MdastTableVisitor,
  MdastTableRowVisitor,
  MdastTableCellVisitor,
  LexicalTableVisitor,
  LexicalTableRowVisitor,
  LexicalTableCellVisitor
} from './table.js'

// math
import {
  MdastMathVisitor,
  MdastInlineMathVisitor,
  LexicalMathVisitor
} from './math.js'

// footnotes
import {
  MdastFootnoteReferenceVisitor,
  MdastFootnoteDefinitionVisitor,
  MdastFootnotesSectionVisitor,
  MdastFootnoteBackrefVisitor,
  LexicalFootnoteReferenceVisitor,
  LexicalFootnoteDefinitionVisitor,
  LexicalFootnotesSectionVisitor,
  LexicalFootnoteBackrefVisitor
} from './footnote.js'

export { isMdastText } from './text.js'

// pre-assembled visitor arrays for convenience
export const importVisitors = [
  MdastRootVisitor,
  MdastParagraphVisitor,
  MdastTextVisitor,
  MdastBreakVisitor,
  MdastHeadingVisitor,
  MdastTOCVisitor,
  MdastAutolinkVisitor,
  MdastLinkVisitor,
  MdastImageVisitor,
  MdastQuoteVisitor,
  MdastListVisitor,
  MdastListItemVisitor,
  MdastCodeBlockVisitor,
  MdastHorizontalRuleVisitor,
  MdastUserMentionVisitor,
  MdastTerritoryMentionVisitor,
  MdastItemMentionVisitor,
  MdastNostrIdVisitor,
  MdastTableVisitor,
  MdastTableRowVisitor,
  MdastTableCellVisitor,
  MdastMathVisitor,
  MdastInlineMathVisitor,
  MdastFootnoteReferenceVisitor,
  MdastFootnoteDefinitionVisitor,
  MdastFootnotesSectionVisitor,
  MdastFootnoteBackrefVisitor,
  ...formattingVisitors
].sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0))

export const exportVisitors = [
  LexicalRootVisitor,
  LexicalParagraphVisitor,
  LexicalTextVisitor,
  LexicalLinebreakVisitor,
  LexicalHeadingVisitor,
  LexicalTOCVisitor,
  LexicalLinkVisitor,
  LexicalEmbedVisitor,
  LexicalMediaVisitor,
  LexicalQuoteVisitor,
  LexicalListVisitor,
  LexicalListItemVisitor,
  LexicalCodeBlockVisitor,
  LexicalHorizontalRuleVisitor,
  LexicalUserMentionVisitor,
  LexicalTerritoryMentionVisitor,
  LexicalItemMentionVisitor,
  LexicalNostrIdVisitor,
  LexicalTableVisitor,
  LexicalTableRowVisitor,
  LexicalTableCellVisitor,
  LexicalMathVisitor,
  LexicalFootnoteReferenceVisitor,
  LexicalFootnoteDefinitionVisitor,
  LexicalFootnotesSectionVisitor,
  LexicalFootnoteBackrefVisitor,
  LexicalGalleryVisitor
].sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0))
